<template>
  <div class="page" ref="page">
    <div class="container offset">
      <div class="imageSection">
        <div class="header">
          <div class="head_l">
            <img
              src="../assets/icon_ldy_LOGO.png"
              width="230"
              height="230"
              alt="PokerBaazi"
              style="border-radius: 15px"
              class="img-fluid weblogo"
            />
          </div>

          <div class="head_r">
            <h2>Golden Jogos:</h2>

            <h3>Truco & Dominó & Buraco</h3>

            <div class="developer">
              <!--        <span class="tag is-rounded">Online Poker</span
              ><span class="tag is-rounded">Win real cash</span> -->
              Guangzhou Weiyu Technology Co., Ltd.
            </div>
          </div>
        </div>
      </div>

      <img src="../assets/bg_ldy_shuju.png" style="width: 100%" alt="" />

      <div
        class="footer_button"
        id="install-button"
        @click="installApp"
        :class="{
          installing: showInstalling && isPwaInstalled,
          waiting: waitingPwa,
        }"
      >
        <div class="txt1" v-if="!waitingPwa">{{ txt1 }}</div>
        <div class="txt2" v-if="!waitingPwa">{{ installButtonText }}</div>

        <div class="txt3" v-if="waitingPwa">
          {{ waitingPwaText }}
        </div>
      </div>
    </div>

    <Intro />

    <AboutArea />

    <Comment />

    <footer
      v-if="isShowFooter"
      @click="installApp"
      :class="{
        installing: showInstalling && isPwaInstalled,
        waiting: waitingPwa,
      }"
    >
      <div class="txt1" v-if="!waitingPwa">{{ txt1 }}</div>
      <div class="txt2" v-if="!waitingPwa">{{ installButtonText }}</div>

      <div class="txt3" v-if="waitingPwa">
        {{ waitingPwaText }}
      </div>
    </footer>
  </div>
</template>

<script lang="ts">
const langMap = {
  极速下载: {
    en: 'Rapid Install',
    pt: 'Instalação Rápida',
  },
  '10秒内下载完成': {
    en: 'Download within 10s',
    pt: 'Transferir dentro de 10 segundos',
  },
  下载中: {
    en: 'Downloading (%s)',
    pt: 'A transferir (%s)',
  },
  开始游戏: {
    en: 'Play',
    pt: 'Jogar',
  },
  秒: {
    en: 'seconds',
    pt: 'segundos',
  },
  等待中: {
    en: 'Waiting',
    pt: 'Aguardando instalação',
  },
};
const lang = 'pt';

import AboutArea from './aboutArea';
import Comment from './comment.vue';
import {
  addScript,
  setDeviceID,
  reportPv,
  reportUv,
  getArgsFromUrl,
} from './statistic.js';
import { preLoadResource } from '../utils';
export default {
  components: {
    AboutArea,
    Comment,
    Intro: function (resolve) {
      setTimeout(() => {
        require(['./intro'], resolve);
      }, 1);
    },
  },
  data() {
    const searchChannel = location.search.match(/(&|\?)channel=(\w+)/),
      channel = searchChannel ? searchChannel[2] : '';
    return {
      channel,
      isShowFooter: false,
      deferredPrompt: null,
      isPwaInstalled: false,
      showInstalling: false,
      // 极速下载	Rapid Install	Instalação Rápida
      // 10秒内下载完成	Download within 10s	Transferir dentro de 10 segundos
      // 下载中	Downloading (%s)	A transferir (%s)
      // 开始游戏	Play	Jogar
      installButtonText: langMap['10秒内下载完成'][lang],
      txt1: langMap['极速下载'][lang],
      waitingPwa: false,
      waitingPwaText: langMap['等待中'][lang],
    };
  },
  beforeCreate() {
    setDeviceID();
    addScript();
  },

  mounted() {
    this.checkPwaInstalled();
    if (!this.isPwaInstalled) {
      this.addPWA();
    }
    if (this.isPwaInstalled) {
      this.beforeInstall();
      this.preload();
    }
    window.addEventListener('scroll', () => {
      this.isShowFooter = window.scrollY > window.innerHeight * 0.9;
    });
    setTimeout(() => {
      reportPv();
      reportUv();
    }, 1);
  },
  methods: {
    addPWA() {
      window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        // 保存事件供后续触发
        this.deferredPrompt = e;
        this.waitingPwa = false;
        this.installApp();
      });
      this.addServiceWorker();
    },
    updateWaitingPwaText(dotCount = 1) {
      // ”...“，省略号的点数会从一点增加到三点，循环播放
      if (!this.waitingPwa) {
        return;
      }
      setTimeout(() => {
        this.waitingPwaText =
          langMap['等待中'][lang] + ' ' + '.'.repeat(dotCount);
        let dotCount2 = dotCount + 1;
        if (dotCount2 > 3) {
          dotCount2 = 1;
        }
        this.updateWaitingPwaText(dotCount2);
      }, 500);
    },
    beforeInstall() {
      // 按钮置灰,mock下载效果，10s 后调用 play
      this.installButtonText = 10 + ' ' + langMap['秒'][lang];
      let count = 10;
      let startTime = new Date().getTime();
      this.showInstalling = true;
      const timer = setInterval(() => {
        if (count <= 1) {
          clearInterval(timer);
          this.play();
          return;
        }

        count--;
        this.installButtonText =
          10 -
          Math.floor((new Date().getTime() - startTime) / 1000) +
          ' ' +
          langMap['秒'][lang];
      }, 1000);
    },
    installApp() {
      // 显示浏览器的安装提示
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt();
        this.deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            // 在 url 上增加个参数，标记为 pwa
            location.href = location.href + '?pwa=true';
          }
          this.deferredPrompt = null;
        });
      } else {
        this.waitingPwa = true;
        this.updateWaitingPwaText();
      }
    },
    addServiceWorker() {
      if ('serviceWorker' in navigator) {
        window.addEventListener('load', function () {
          navigator.serviceWorker.register('/sw.js').then(
            function (registration) {
              console.log(
                'ServiceWorker registration successful with scope: ',
                registration.scope
              );
            },
            function (error) {
              console.log('ServiceWorker registration failed: ', error);
            }
          );
        });
      }
    },

    checkPwaInstalled() {
      const isPwa = getArgsFromUrl('pwa');
      this.isPwaInstalled = isPwa;
    },

    // downloadApp() {
    //   reportClickDownloadEvery();
    //   reportClickDownloadOnce();
    //   setTimeout(() => {
    //     window.location.href =
    //       'https://app.goldenjogos.com/offical/goldenjogos.apk';
    //   }, 100);
    // },
    play() {
      // 跳转到相对路径 /game/index.html
      const path = window.location.pathname;
      window.location.href = path.replace('index.html', '') + 'game/index.html';
    },
    preload() {
      const host = window.location.host;
      const resourceList = [];
      resourceList.forEach((resource) => {
        preLoadResource(host + resource.path, resource.type);
      });
    },
  },
  watch: {
    // isPwaInstalled(newVal) {
    //   if (newVal) {
    //     this.installButtonText = 'play';
    //   }
    // },
  },
};
</script>

<style scoped>
.page {
  width: 100%;
  height: 100%;
  padding-top: 4rem;
}

* {
  box-sizing: border-box;
  font-family: NotoSansHansRegular;
}

.container {
  width: 100%;
  height: auto;
}

.imageSection {
  min-height: 18.2rem;
  display: flex;
  flex-direction: column;
  padding-bottom: 0 !important;
}

.header {
  display: flex;
  margin-bottom: 2rem;
  margin-top: 0;
}

.head_l {
  width: 6.8rem;
  margin-right: 2.5rem;
}

.head_l .weblogo {
  width: 100%;
  height: auto;
}

.head_r {
  width: 80%;
}

.head_r h2 {
  margin-bottom: 0rem;
  font-weight: 700;
  font-size: 2.4rem;
  color: #1e1e1e;
}

.head_r h3 {
  margin-bottom: 0.6rem;
  color: #1e1e1e;
  font-size: 2.4rem;
}

.developer {
  margin-bottom: 0.6rem;
  color: #3da26f;
  font-size: 1.43rem;
  display: flex;
}

.developer .tag {
  border: 0.1rem solid #d0d0d0;
  font-size: 1.2rem;
  border-radius: 3rem;
  display: flex;
  min-height: 2.2rem;
  justify-content: center;
  align-items: center;
  padding-left: 0.9rem;
  padding-right: 0.9rem;
  margin-right: 0.3rem;
  color: #1e1e1e;
  width: fit-content;
  line-height: 1.5;
}

.play_header {
  width: 100%;
  min-height: 5.2rem;
  height: auto;
}

.play_actives {
  width: 100%;
  min-height: 5.2rem;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.play_actives .play_step {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
}

.play_actives .play_step::before {
  content: '|';
  position: absolute;
  right: 0;
  color: rgba(0, 0, 0, 0.2);
  font-size: 2.4rem;
  top: 50%;
  transform: translateY(-50%);
}

.play_actives .play_step span {
  font-size: 1.5rem;
  font-weight: bold;
  display: block;
}

.play_actives .play_step p {
  font-size: 1.15rem;
  margin-top: -0.5rem;
  line-height: 2.7rem;
}

.footer_button {
  text-align: center;
  padding: 0.5rem 1rem;
  margin: 1rem auto 1.5rem auto;
  margin-bottom: 0;
  cursor: pointer;
  font-size: 1.8rem;
  background-color: #39875f;
  border: 1px solid #39875f;
  border-radius: 0.4rem;
  color: #fff;
  width: 100%;
  height: 3.5rem;
  font-weight: bold;
  text-transform: uppercase;
  line-height: 1.3;
}
.txt1 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.txt1::before {
  content: '';
  margin-right: 5px;
  display: inline-block;
  width: 1rem;
  height: 1rem;
  background-image: url(../assets/shandian.png);
  background-repeat: no-repeat;
  background-size: contain;
  border-radius: 50%;
}
.txt3 {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.installing {
  background-image: url(../assets/installing-bg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-color: transparent;
  border: none;
}

.waiting {
  background-image: url(../assets/installing-bg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-color: transparent;
  border: none;
}

footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 5rem;
  background-color: #39875f;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  text-transform: uppercase;
}
</style>

<style>
@font-face {
  font-family: NotoSansHansMedium;
  src: url(../assets/font/NotoSansHans-Medium.otf);
}

@font-face {
  font-family: NotoSansHansDemiLight;
  src: url(../assets/font/NotoSansHans-DemiLight.otf);
}

@font-face {
  font-family: NotoSansHansRegular;
  src: url(../assets/font/NotoSansHans-Regular.otf);
}

.offset {
  padding-left: 0.7rem;
  padding-right: 0.7rem;
  /*   padding-left: 2.3rem;
  padding-right: 2.3rem; */
}

.viewZone {
  width: 34.6rem;
  margin-left: 0.7rem;
  margin-right: 0.7rem;
  /*   width: 31.4rem;
  margin-left: 2.3rem;
  margin-right: 2.3rem; */
  overflow-x: scroll;
  margin-top: 1.8rem;
}
</style>
